module.exports = __webpack_public_path__ + "static/sofiapro-700-2c99e251885536b05ba237b2600a77a7.woff";